import {
  ContentModule,
  ModuleProperties,
  sizingSchema,
} from '@backstage-components/base';

import {SchemaType} from './ImageDefinition';

/**
 * This is adapted from Streamable Server's GQL `Media` (and its TS IMedia).
 */
export type MediaLegacy = {
  id: string;
  mediaId: string;
  altDescription?: string;
  s3URL?: string;
  s3Path?: string;
  s3Bucket?: string;
  originalFilename?: string;
  contentType?: string;
  width?: number;
  height?: number;
  opticalHeight?: number;
  opticalWidth?: number;
  filesize?: number;
  status: string;
  assetURL: string;
  transferID?: string;
  transferStatus?: string;
  securityLevel?: string;
};

export type HasMediaId = {
  mediaId: string;
  altDescription?: string;
  isNotFound?: boolean;
};
/**
 * S3Media starts as a mediaId, but can swap in.
 */
export type S3Media = MediaLegacy | HasMediaId;

export const ObjectFitModes = ['cover', 'contain', 'none'] as const;

export type IImageProps = ModuleProperties &
  Omit<SchemaType, 'src' | 'aspectRatioImage'>;

export interface AspectRatioProps {
  aspectRatioImage?: {
    useAspectRatioImage?: boolean;
    ratio?: {
      width?: number;
      height?: number;
    };
    skeletonColor?: {
      startColor?: string;
      endColor?: string;
    };
    transitionDuration?: string;
  };
}

export type ImageComponentDefinition = ContentModule<
  'Image',
  SchemaType & IImageProps & AspectRatioProps
>;

export type SizingProps = Pick<
  typeof sizingSchema['sizing'],
  'width' | 'height' | 'maxWidth' | 'maxHeight' | 'minHeight' | 'minWidth'
>;
